import { GrowthBook, configureCache } from '@growthbook/growthbook-react';
import * as amplitude from '@amplitude/analytics-browser';
import { sendEventService } from '../services/events.service';
import { getAnonymousId } from '../utils/anonymousId';
import { getEventSource } from '../utils/general.util';
import { GROWTHBOOK_CACHE_MAX_AGE_MS } from '@/features/maintenance/constants/flag';

// Tope de edad del caché local (el default del SDK son 4 h): un payload viejo
// con `web-mantenimiento` encendido no puede dejar fuera a nadie tras apagarlo.
configureCache({ maxAge: GROWTHBOOK_CACHE_MAX_AGE_MS });

const growthbookFile = new GrowthBook({
	apiHost: 'https://cdn.growthbook.io',
	clientKey: import.meta.env.VITE_GROWTHBOOK_KEY,
	subscribeToChanges: true,
	enableDevMode: true,
	attributes: {
		anonymous_id: getAnonymousId(),
	},
	trackingCallback: (experiment, result) => {
		const payload = {
			experiment_id: experiment.key,
			variation_id: result.variationId,
			variation_value: result.value,
		};
		amplitude.track('experiment_viewed', payload);
		sendEventService({
			event: 'experiment_viewed',
			// Estaba quemado en 'web', así que TODA exposición se guardaba como
			// desktop y ningún experimento se podía cortar por dispositivo. Se lee
			// el mismo helper que usa `useEvents`, con el media query en crudo
			// porque aquí no hay contexto de React.
			source: getEventSource(
				window.matchMedia('(max-width: 768px)').matches,
			),
			eventPayload: payload,
		}).catch(() => {});
	},
});


// Kick off the feature fetch once at boot (module load), in parallel with the
// rest of the app — every route shares this single in-flight request. The
// authenticated boot splash awaits readiness via `useFeaturesReady`; public
// routes (login) render without waiting since they read no flags. Errors are
// swallowed so the readiness signal always settles (the hook also has a
// wall-clock timeout as a safety release for a blocked CDN / offline boot).
export const featuresReadyPromise = growthbookFile.loadFeatures().catch(() => {});

// Exponer en window para debugging
if (typeof window !== 'undefined') {
	(window as any).growthbook = growthbookFile;
	(window as any).debugGrowthbook = () => {

	};

}

export default growthbookFile;
